// [SolabsForce] Locale do date-fns acompanhando o idioma da interface.
//
// O upstream chama formatDistanceToNow/format sem `locale`, então toda data
// relativa ("15 days ago") sai em inglês mesmo com a conta em pt_BR. Este
// módulo guarda o locale atual do app e entrega o objeto do date-fns
// correspondente; o timeHelper o injeta em todas as chamadas.
//
// Quem define o idioma é o entrypoint do dashboard (watch em
// i18n.global.locale), então a troca de idioma na conta ou no perfil já vale
// sem recarregar. Widget, portal e survey não chamam o setter e continuam em
// inglês, como no upstream.
//
// Só importamos os locales que usamos, para não inflar o bundle com os ~90
// do date-fns. Idioma sem entrada aqui cai no padrão do date-fns (inglês).
import ptBR from 'date-fns/locale/pt-BR';
import pt from 'date-fns/locale/pt';

const DATE_FNS_LOCALES = {
  pt_BR: ptBR,
  pt,
};

let currentLocale;

/**
 * Converte o código de idioma do app (pt_BR, pt-BR, pt) no locale do date-fns.
 * @param {string} code - Código de idioma do i18n.
 * @returns {Object|undefined} Locale do date-fns, ou undefined para inglês.
 */
export const resolveDateFnsLocale = code => {
  if (!code) return undefined;
  const normalized = String(code).replace('-', '_');
  return (
    DATE_FNS_LOCALES[normalized] || DATE_FNS_LOCALES[normalized.split('_')[0]]
  );
};

/**
 * Define o idioma usado pelos helpers de data.
 * @param {string} code - Código de idioma do i18n (ex.: pt_BR).
 */
export const setDateFnsLocale = code => {
  currentLocale = resolveDateFnsLocale(code);
};

/** @returns {Object|undefined} Locale atual do date-fns. */
export const getDateFnsLocale = () => currentLocale;

/**
 * Opções para repassar às funções do date-fns, com o locale atual quando houver.
 * @param {Object} [options={}] - Opções originais da chamada.
 * @returns {Object} Opções acrescidas de `locale`.
 */
export const withDateFnsLocale = (options = {}) =>
  currentLocale ? { ...options, locale: currentLocale } : options;
